import React from 'react'
import { Bar } from 'react-chartjs-2'
import { useTranslation } from 'react-i18next';

const EnvironmentalSocialDistribution = ({ isLoan, isIgr, efaLegend, efaLegendNext, dataBar, options }) => {
    const { t } = useTranslation();

    return (
        <div className="card-early">
            <p className='title-cards-early'><b>{t('extended_report.distribution_environmental_social_performance')}</b></p>
            <p className='sub-title-cards-early'>{t('extended_report.subtitle_environmental_performance')}</p>
            {(isLoan | isIgr) ? (
                <>
                    <div className='legends-flex'>
                        {efaLegend.map(({ label, value, color }) => (
                            <div key={label}>
                                <div className='safeguard-distribution-early'>
                                    <div style={{ width: '11px', height: '11px', backgroundColor: color, borderRadius: '50%', border: 'solid 1px #000' }}></div>
                                    <p className='sub-title-cards-early'>{label}</p>
                                </div>
                                <p className='text-distribution-early'>{`${value} ${t('one_pager_report.projects')}`}</p>
                            </div>
                        ))}
                    </div>
                    <div className='efa-legend-next-flex'>
                        {efaLegendNext.map(({ label, value, color }) => (
                            <div key={label}>
                                <div className='safeguard-distribution-early'>
                                    <div style={{ width: '11px', height: '11px', backgroundColor: color, borderRadius: '50%', border: 'solid 1px #000' }}></div>
                                    <p className='sub-title-cards-early'>{label}</p>
                                </div>
                                <p className='text-distribution-early'>{`${value} ${t('one_pager_report.projects')}`}</p>
                            </div>
                        ))}
                    </div>

                    <div className='bar-content-distribution'>
                        <p>{t('one_pager_report.projects')}</p>
                        <Bar data={dataBar} options={options} />
                    </div>
                </>
            ) : (
                <div className='na-content'>
                    <p>N/A</p>
                </div>
            )}
        </div>
    )
}

export default EnvironmentalSocialDistribution